export default {
  namespaced: true,
  name: 'SLSUsuarioRepresentanteStore',
  state: {
    representantesNaoSelecionados: [],
    representantesSelecionados: [],
    loading: false,
    filtersNaoSelecionado: {
      page: 1,
      perPage: 8,
      sortBy: null,
      sortDesc: null,
      codigo: null,
      representanteNome: null,
    },
    filtersSelecionado: {
      page: 1,
      perPage: 8,
      sortBy: null,
      sortDesc: null,
      codigo: null,
      representanteNome: null,
    },

  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setCodigoNaoSelecionado(state, payload) {
      state.filtersNaoSelecionado.codigo = payload;
    },
    setRepresentanteNomeNaoSelecionado(state, payload) {
      state.filtersNaoSelecionado.representanteNome = payload;
    },
    setCodigoSelecionado(state, payload) {
      state.filtersSelecionado.codigo = payload;
    },
    setRepresentanteNomeSelecionado(state, payload) {
      state.filtersSelecionado.representanteNome = payload;
    },
    setPageNaoSelecionado(state, payload) {
      state.filtersNaoSelecionado.page = payload;
    },
    setFiltersNaoSelecioando(state, payload) {
      state.filtersNaoSelecionado = payload;
    },
    setFiltersSelecionados(state, payload) {
      state.filtersSelecionado = payload;
    },
    setUsuariosRepresentantes(state, payload) {
      state.usuariosRepresentantes = payload;
    },
    setImagensPorMarca(state, payload) {
      state.imagensPorMarca = payload;
    },
    setRepresentantesNaoSelecionados(state, payload) {
      state.representantesNaoSelecionados = payload;
    },
    setRepresentantesSelecionados(state, payload) {
      state.representantesSelecionados = payload;
    },
  },
  getters: {
    getLoading(state) {
      return state.loading;
    },
    getFiltersNaoSelecionado(state) {
      return state.filtersNaoSelecionado;
    },
    getFiltersSelecionado(state) {
      return state.filtersSelecionado;
    },
    getRepresentantesNaoSelecionados(state) {
      return state.representantesNaoSelecionados;
    },
    getRepresentantesSelecionados(state) {
      return state.representantesSelecionados;
    },
  },
};
